import React, { Component } from "react";
import { style } from "typestyle";
import Input from "../../../../components/Input";
// @ts-ignore
import Markdown from "../../../../components/Markdown";

import { ActionProps, ActionCollapsedProps } from "../_ActionProps";

type ActionTextProps = ActionProps<string> & {
  regexp?: string;
  defaultValue?: string;
};
type ActionTextState = {
  isFocused: boolean;
  value: string;
};

export class ActionText extends Component<ActionTextProps, ActionTextState> {
  constructor(props: ActionTextProps) {
    super(props);
    const { value, defaultValue } = props;
    this.state = {
      value: value || defaultValue || "",
      isFocused: false,
    };
  }

  componentDidMount() {
    if (this.state.value) {
      this.props.onInputSuccess(this.state.value);
    }
  }

  render() {
    const { label } = this.props;

    return (
      <div>
        <Input
          label={label}
          value={this.state.value}
          className={style({ width: "50%" })}
          onChange={this.onChange}
          error={this.getError(this.state.value)}
        />
      </div>
    );
  }

  onChange = (newValue: string) => {
    this.setState({ value: newValue });
    if (this.getError(newValue)) {
      this.props.onInputFailure(newValue);
      return;
    }
    this.props.onInputSuccess(newValue);
  };

  getError(value?: string): string | null {
    const { regexp } = this.props;
    if (!value) {
      return null;
    }
    if (regexp) {
      const reg = new RegExp(regexp);
      if (!reg.test(value)) {
        return "invalid format";
      }
    }
    return null;
  }
}

export const ActionTextCollapsed = ({
  label,
  value,
}: ActionCollapsedProps<string>) => (
  <div
    className={style({
      fontSize: "14px",
      lineHeight: "20px",
    })}
  >
    {label && (
      <div
        className={style({
          marginBottom: "4px",
          lineHeight: "24px",
          color: "#7A7A82",
        })}
      >
        <Markdown text={label} />
      </div>
    )}
    <div>{value}</div>
  </div>
);
